export default () => ({
  trigger: {
    name: 'last_order_block.select_all_orders',
    params: {},
  },
  config: {
    event: {
      name: 'select_all',
      params: {
        sub_feature: null,
        content: 'all_orders',
      },
    },
  },
});
